import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ErrorState {
  message?: string;
}

const initialState: ErrorState = {
};

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    setErrorMessage: (state, action: PayloadAction<string>) => {
      return {
        message: action.payload
      };
    },
    setError: (state, action: PayloadAction<Error>) => {
      return {
        message: action.payload.message
      };
    },
    clearErrorMessage: () => {
      return {};
    }
  },
});

export const {
  setErrorMessage,
  setError,
  clearErrorMessage
} = errorSlice.actions;
